import {
    createContext,
    ReactNode,
    useContext,
} from 'react'

import {FieldValues, useForm, UseFormReturn} from "react-hook-form";
import {ModalWizardSideNav} from "@/components/new/modalWizardSideNav/ModalWizardSideNav";

interface ModalWizzarSideNavContextProps<TDefaultValues> {
    data?: TDefaultValues
}

// Define the context type
interface ModalWizzarSideNavContextType<TDefaultValues> {
    data?: TDefaultValues
    useFormWizzard:  UseFormReturn<FieldValues,any,FieldValues>
}
const ModalWizzarSideNavContext = createContext<ModalWizzarSideNavContextType<any> | undefined>(undefined)

export const ModalWizardSideNavProvider = <TDefaultValues,>(
  {
      data,
      children
  }: ModalWizzarSideNavContextProps<TDefaultValues> & { children: ReactNode }) => {

    const useFormWizzard = useForm()

    const contextValue: ModalWizzarSideNavContextType<TDefaultValues> = {
        useFormWizzard,
        data: data
    }

    return (
      <ModalWizzarSideNavContext.Provider value={contextValue}>
          {children}
      </ModalWizzarSideNavContext.Provider>
    )
}

// Custom hook to use the table context
export const useModalWizardSideNavContext = <TDefaultValues,>() => {
    const context = useContext(ModalWizzarSideNavContext) as ModalWizzarSideNavContextType<TDefaultValues> | undefined;
    if (context === undefined) {
        throw new Error(
          'useTableContext must be used within a TableContextProvider'
        )
    }
    return context
}
